import { gql } from '@apollo/client';

export const GET_WORK_PROGRESS_BAG_PARCEL_DETAILS = gql`
  query GetWorkProgressBagParcelDetails($filter: WorkProgressBagParcelDetailFilterInput!) {
    getWorkProgressBagParcelDetails(filter: $filter) {
      content {
        id
        hubId
        arrivalDate
        parcelNumber
        customerId
        customerName
        bagNumber
        mawb
        overallStatus
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export interface WorkProgressBagParcelDetail {
  id: string;
  hubId: number;
  arrivalDate: string;
  parcelNumber: string;
  customerId: number;
  customerName: string;
  bagNumber: string;
  mawb: string;
  overallStatus: string;
}

export interface GetWorkProgressBagParcelDetailsResponse {
  getWorkProgressBagParcelDetails: {
    content: WorkProgressBagParcelDetail[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
  };
}

export interface WorkProgressBagParcelDetailFilterInput {
  hubId: number;
  arrivalDateStart: string;
  arrivalDateEnd: string;
  /** 不传或 null：有提单号 + 无提单号合并（与 KPI / 客户行包裹差异汇总一致） */
  bagType?: 0 | 1 | null;
  customerId?: number | null;
  /** 仅 bagType=1；与明细列 mawb 一致，勿把大包号写入此字段 */
  mawb?: string | null;
  /** 与明细列 bag_number 一致；bagType=1 时可与 mawb 联用收窄大包，bagType=0 时按大包号筛选 */
  bagNumber?: string | null;
  /** 不传/null 时后端按差异包裹口径默认仅未入库（is_inbound=0） */
  isInbound?: boolean | null;
  /** true：仅查询已入库大包内的包裹差异 */
  inboundBagOnly?: boolean | null;
  page?: number;
  pageSize?: number;
}

